























































import { i18n } from '@tt4b/ttam-i18n';
import { VideoPackageStatus, VerticalCreativeStrategy } from '@tt4b/ttam-enums';
import { useJumpCatalog, watchBroadcastChannel, BroadcastChannelEvents } from '@tt4b/ttam-hooks';
import { computed, defineComponent, ref, toRefs, watch, PropType } from '@vue/composition-api';
import { useSelectVideoPackage, useGetPreviewProducts } from '../../../catalogs-preview';
import videoEmptyPng from '@tt4b/ttam-assets/src/images/creative/video-empty.png';
import singleVideoEmptyPng from '@tt4b/ttam-assets/src/images/creative/single-video-empty.png';
import NotHasTemplate from './components/not-has-template.vue';
import SelectTemplate from './components/select-template.vue';
import { trackEvent } from '@tt4b/ttam-utils';

const name = 'ttam-material-catalog-vpkg-select';

export default defineComponent({
  name,
  components: { NotHasTemplate, SelectTemplate },

  props: {
    isSelected: { type: Boolean, default: false },
    isHoverButtons: { type: Boolean, default: false },
    catalogId: { type: String, default: '' },
    bcId: { type: String, default: '' },
    templateId: { type: String, default: '' },
    pSetId: { type: String, default: '' },
    productIds: { type: Array as PropType<string[]>, default: () => [] },
    creativeStrategy: { type: Number },
    isCreate: { type: Boolean, default: true },
  },

  setup(props, { emit }) {
    const { catalogId, bcId, templateId, pSetId, productIds, creativeStrategy, isCreate } = toRefs(props);

    const viDropdown = ref();
    const { previewProductList, getPreviewProducts } = useGetPreviewProducts(catalogId, bcId, pSetId, productIds);
    const { curVideoPackage, videoPackages, getVideoPackages, isLoading } = useSelectVideoPackage(
      catalogId,
      bcId,
      templateId,
    );
    const { jumpVideoPage } = useJumpCatalog(catalogId, bcId);

    const isSmartCreative = computed(() => creativeStrategy.value === VerticalCreativeStrategy.SMART_CREATIVE);

    // 可能没拉取到预览商品，也可能拉取的商品没有视频，所以判断第1个商品就可以
    const hasPreviewVideoUrl = computed(() => previewProductList.value?.[0]?.video?.videoId);

    const isShowUnavailableAlert = computed(() => !isCreate.value && templateId.value && !curVideoPackage.value);

    const videoPackagesAll = computed(() =>
      (videoPackages.value ?? []).map(vpkg => ({
        value: vpkg.packageId,
        label: vpkg.name,
        disabled: VideoPackageStatus.Approved !== vpkg.auditStatus,
      })),
    );

    const onGenerate = (isShow = true) => {
      try {
        jumpVideoPage(isShow);
      } catch (e) {
        // do nothing
      }
    };

    const onClick = tid => emit('change', tid);

    const handleRefresh = () => {
      if (templateId.value) {
        onClick('');
      }
      getVideoPackages();
    };

    // watch(catalogId, getVideoPackages);
    getVideoPackages();

    watch(
      videoPackages,
      async () => {
        if (videoPackages.value.length < 1) {
          await getPreviewProducts();
        }
      },
      { immediate: true },
    );

    const onVideoPackagesRefresh = () => {
      getVideoPackages();
      trackEvent('module_ad_creative_nonshop_video_template_refresh');
    };

    watchBroadcastChannel(BroadcastChannelEvents.CATALOG_VIDEOTPL_CHANGE, onVideoPackagesRefresh);

    return {
      name,
      VideoPackageStatus,
      isLoading,
      isSmartCreative,
      hasPreviewVideoUrl,
      viDropdown,
      curVideoPackage,
      videoPackages,
      videoPackagesAll,
      videoEmptyPng,
      singleVideoEmptyPng,
      isShowUnavailableAlert,
      onClick,
      onGenerate,
      jumpVideoPage,
      handleRefresh,
      onVideoPackagesRefresh,
    };
  },
});
